import React from 'react';
import { Paragraph3 } from '@cian/ui-kit';

import { ContentRow } from '../../../../components/ContentRow';
import { useOfferContext } from '../../../../context';
import { AgentTitle } from '../../../../components/Agent/AgentTitle';

export function AgentTitleContainer() {
  const { agentName, agentInfo, agentProfileLink } = useOfferContext();

  if (agentName && !agentInfo) {
    return <AgentTitle title={agentName} url={agentProfileLink} />;
  }

  if (agentName && agentInfo) {
    return (
      <>
        <ContentRow>
          <AgentTitle title={agentName} url={agentProfileLink} />
        </ContentRow>

        <Paragraph3 color="gray60_100">{agentInfo}</Paragraph3>
      </>
    );
  }

  return null;
}
